import { Tier } from '../enums';
import { enumToList } from './enum-to-list';
import { IdName } from '../models';

export function getTier(tierType: Tier): string {
  switch (tierType) {
    case Tier.Basic:
      return 'Basic';
    case Tier.Professional:
      return 'Professional';
    case Tier.Enterprise:
      return 'Enterprise';
  }
}

export function getTiersList(): IdName[] {
  return enumToList(Tier, getTier);
}
